import * as React from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Chip
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { CTextField } from '../../../../components/common/Modal';

export const CubeTable = ({ 
  cubes, 
  availableDimensions,
  onCubeNameChange,
  onDimensionToggle,
  onRemoveCube
}) => {
  if (cubes.length === 0) {
    return null;
  }

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600, backgroundColor: '#f5f5f5' }}>
              Cube Name
            </TableCell>
            <TableCell sx={{ fontWeight: 600, backgroundColor: '#f5f5f5' }}>
              Dimensions
            </TableCell>
            <TableCell sx={{ fontWeight: 600, backgroundColor: '#f5f5f5', width: 80 }}>
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {cubes.map((cube) => (
            <TableRow key={cube.id}>
              <TableCell>
                <CTextField
                  size="small"
                  variant="outlined"
                  value={cube.name}
                  onChange={(e) => onCubeNameChange(cube.id, e.target.value)}
                  placeholder="Enter cube name"
                  fullWidth
                />
              </TableCell>
              <TableCell>
                {availableDimensions.length > 0 ? (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, maxWidth: 300 }}>
                    {availableDimensions.map((dimension) => (
                      <Chip
                        key={dimension}
                        label={dimension}
                        size="small"
                        variant={cube.dimensions.includes(dimension) ? "filled" : "outlined"}
                        color={cube.dimensions.includes(dimension) ? "primary" : "default"}
                        onClick={() => onDimensionToggle(cube.id, dimension)}
                        sx={{ 
                          cursor: 'pointer',
                          '&:hover': {
                            backgroundColor: cube.dimensions.includes(dimension) 
                              ? 'primary.dark' 
                              : 'action.hover'
                          }
                        }}
                      />
                    ))}
                  </Box>
                ) : (
                  <Typography variant="caption" color="text.secondary">
                    {cube.dimensions.length > 0 
                      ? `${cube.dimensions.length} dimension(s) selected` 
                      : 'No dimensions available - sync metadata first'
                    }
                  </Typography>
                )}
              </TableCell>
              <TableCell>
                <IconButton
                  size="small"
                  onClick={() => onRemoveCube(cube.id)}
                  color="error"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

